// extracted by mini-css-extract-plugin
export default {"section":"Ks-z","sectionTitle":"Ls-z","fieldWrapper":"Ms-z","formField":"Ns-z","disabled":"Os-z","formLabel":"Ps-z"};